import Controller from "@ember/controller";

export default class CirclesController extends Controller {}
